module.exports = __webpack_public_path__ + "img/khaanpin3-red-full.c340120d.png";